/* eslint-disable */
import * as Types from '../../../models/schema';

import { UserFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateUserVariablesDTO = Types.Exact<{
  data: Types.UserCreateInputDTO;
}>;


export type CreateUserDTO = (
  { __typename?: 'Mutation' }
  & { createOneUser: (
    { __typename?: 'User' }
    & UserFragmentDTO
  ) }
);


export const CreateUserDocumentDTO = gql`
    mutation createUser($data: UserCreateInput!) {
  createOneUser(data: $data) {
    ...userFragment
  }
}
    ${UserFragmentDTO}`;
export type CreateUserMutationFnDTO = Apollo.MutationFunction<CreateUserDTO, CreateUserVariablesDTO>;

/**
 * __useCreateUser__
 *
 * To run a mutation, you first call `useCreateUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUser, { data, loading, error }] = useCreateUser({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUser(baseOptions?: Apollo.MutationHookOptions<CreateUserDTO, CreateUserVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDTO, CreateUserVariablesDTO>(CreateUserDocumentDTO, options);
      }
export type CreateUserHookResult = ReturnType<typeof useCreateUser>;
export type CreateUserMutationResultDTO = Apollo.MutationResult<CreateUserDTO>;
export type CreateUserMutationOptionsDTO = Apollo.BaseMutationOptions<CreateUserDTO, CreateUserVariablesDTO>;